import React from "react";
import PropTypes from "prop-types";
import { IconButton, TextField } from "@mui/material";

// A self-contained component for a text field with a color picker
function ColorInputField({ label, color, setColor }) {
  return (
    <div style={{ position: "relative" }}>
      <TextField
        type="text"
        label={label}
        value={color}
        onChange={(e) => setColor(e.target.value)}
        fullWidth
        variant="outlined"
      />
      <IconButton
        sx={{
          position: "absolute",
          right: 8,
          top: "50%",
          transform: "translateY(-50%)",
          p: 0.5,
        }}
      >
        <input
          type="color"
          value={color}
          onChange={(e) => setColor(e.target.value)}
          style={{
            width: 24,
            height: 24,
            border: "none",
            background: "transparent",
            cursor: "pointer",
          }}
        />
      </IconButton>
    </div>
  );
}

ColorInputField.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  setColor: PropTypes.func.isRequired,
};

export default ColorInputField;
